import Vue from 'vue'
import _ from 'lodash'
import ComponentMixin from "@/components/ComponentMixin.js";
import utils from './utils'
import nodeUtils from '@/builder/NodeUtils'
// import builderFunctions from './BuilderFunctions'
import clientApiFunctions from '@/api/ClientApiFunctions.js';

/**
 * Esta API permite crear componentes dinamicamente.
 * Cuando arranca un formulario, lo primero que se hace es crear los componentes.
 * Esta creacion ocurre aqui, en base a objetos JSON.
 */

let api = {
    components: {},
    clientAPI: null
}

api.setClientAPI = (a) => {
    api.clientAPI = a
}

api.createMethods = (script, targetObject, bindScope) => {
    if (!script) return targetObject;
    // puede haber 2 maneras de definirlos: en js o como json.
    //      json        { a: () => window.console.log }
    //      js          let api = {}; api.a = () => window.console.log }; return api;
    // tambien hay un hibrido que es js devolviendo un objeto json:
    //      hibrido     return { a: () => window.console.log }

    const comp_identification = `COMPONENTE: ${targetObject?.name || bindScope?.name} - ${targetObject?.componentType || bindScope?.componentType}`
    let jsonWrapper = `" /* ${comp_identification} */ use strict"; return (${script})`
    let funWrapper = `" /* ${comp_identification} */ use strict"; ${script}`
    let fun = (script.trim().startsWith('{')) ? jsonWrapper : funWrapper;
    // window.console.log('fun>', fun)

    let f = Function(["me"], fun);
    let api = f.bind(bindScope)()

    Object.assign(targetObject, api)
    return targetObject;
}


let JSONHelper = {
    array: (o) => {
        if (Array.isArray(o)) return o;
        if (utils.isString(o)) return JSON.parse(o);
        throw 'No se puede convertir en un array ' + o
    }
}


let tiposInstanciados = {}

/**
 * Crea un componente Vue en base a la definicion.
 * @param {*} componentDefinition
 */
api.registerComponent = (componentDefinition) => {
    //  window.console.log(componentDefinition.id, 'registrando >', componentDefinition.propsData)
    let props = [...(JSONHelper.array(componentDefinition.props || [])), ...ComponentMixin.COMMON_PROPS, ...Object.keys(componentDefinition.propsData || {})]
    let html = componentDefinition.expression || '<span></span>'
    let data = componentDefinition.data || {}

    /*
    window.console.log('props>', props)
    window.console.log('data>', data)
    window.console.log('methodNames>', methodNames)
    */
    let cname = componentDefinition.id || 'c_' + new Date().getTime()
    Vue.component(cname, {
        template: html,
        mixins: [ComponentMixin],
        name: cname.replaceAll(' ', '_').replaceAll('.', '').replaceAll('(', '').replaceAll(')', '').replaceAll('-', ''),
        props,

        data() {
            let p = Object.assign({}, data, { api: api.clientAPI, instance_id: window.api.generateUUID() }); // aniadir mas propiedades en component mixin
            return p
        },
        beforeMount() {
            // this.name = window.api.eval(this.instanceName || this.instance_name || this.propsData?.instanceName || this.propsData?.instance_name || this.name)
            // if (this.name) this.$root.$refs[this.name] = this;
            // window.console.log(`Inicializando elemento: ${this.name || this.$parent.name}`)

            // if (this.node?.nodeUUID) this.node.nodeUUID = window.api.generateUUID()



            let boundMethods = {
                constructor: () => { },
                destructor: () => { },
                typeConstructor: () => { },
                x: (k) => window.api.get(k),
                me: () => window.api.getComponent(this.propsData?.instance_name || this.name || this.node?.name),
                eval: (expr, ...params) => {
                    /*
                    console.log('this.eval', expr, ...params)

                    if (expr?.indexOf('debugg') > 0) {
                        console.log('api.evalExpression', { expr, params })
                        eval('debugger')
                    }
                    */

                    return window.api.eval(expr, this/* this.me()*/, ...params)
                },

                get_children: () => {
                    const treeToArray = tree => {
                        // Si el nodo tiene un atributo $children, lo recorremos recursivamente
                        let result = [];

                        // Verificamos si el nodo tiene el atributo $children
                        if (tree && tree.$children && Array.isArray(tree.$children)) {
                            // Añadimos el nodo actual al array
                            if (tree != this) result.push(tree);

                            // Recorremos cada hijo del nodo y lo añadimos al array
                            tree.$children.forEach(child => {
                                result = result.concat(treeToArray(child)); // Llamada recursiva
                            });
                        } else {
                            // Si no tiene hijos, simplemente lo añadimos
                            result.push(tree);
                        }

                        return result;
                    }
                    eval('debugger')
                    let c = treeToArray(this)
                    c = window._.uniqBy(c, 'name').filter(e => e.name)
                    return c
                },

                getParent: (k) => {
                    const parent = (elem, n) => {
                        while (n > 0 && elem) {
                            const name = elem?.name
                            do {
                                // console.log('getParent', {n, k, elem, parent: elem?.$parent?.name, name})
                                elem = elem?.$parent
                                if (!elem) break
                            } while (!elem.name || elem.name == name)
                            n = n - 1
                        }
                        return elem
                    }

                    return parent(this, k === undefined ? 1 : k)
                },
                evalAttributeAsFunction: (attr) => {
                    let n = (this.node || {})
                    let expr = (n.propsData || {})[attr] || this[attr]
                    // if (this.name === 'centroAyuda')

                    let r = (expr && expr.length) ? clientApiFunctions.executeJSSync(expr, this) : false
                    // window.console.log(attr, 'evalAttributeAsFunction', r, this)
                    return r
                },
                redraw: () => {
                    _.each(this.children, c => window.api.getComponent(c.name)?.redraw())
                    this.$forceUpdate()
                },
                registerDomListeners: () => {
                    if (!this?.node?.nodeUUID) return
                    let expr = this.node.expression

                    if (this.node.componentType != 'HTMLText') {
                        expr = componentDefinition.expression
                    }

                    if (!expr) return
                    // encontrar @evento= o v-on:evento=
                    const regex = /(?:@|v-on:)([a-zA-Z0-9_:.]+)\s*=/g
                    let match

                    window.domListeners = window.domListeners || {}
                    while ((match = regex.exec(expr)) !== null) {
                        const eventName = match[1]
                        window.domListeners[eventName] = window.domListeners[eventName] || new Set()
                        window.domListeners[eventName].add(this.node.nodeUUID)
                    }
                },
            }
            _.each(boundMethods, (m, k) => this[k] = m)

            api.createMethods(componentDefinition.methods, this, this)
        },
        mounted() {
            // el typeConstructor se invoca solo una vez por tipo de componente (clase), y constructor para cada elemento del formulario (instancia)
            if (!tiposInstanciados[cname]) this.typeConstructor()

            // por un motivo que se me escapa, vue instancia 2 veces cada componente creado en api.getSchema - asi que se salta la primera instancia y no se invoca su constructor
            // los elementos creados dentro de un template (no como un nodo, sino introduciendo el tag HTML en el template de otro componente) solo se crean una vez, asi que si se invoca el constructor


                if (this._inited) return; // evita duplicar suscripciones
                this._inited = true;
                this.constructor()
                if (this.propsData?.constructor) this.eval(this.propsData?.constructor)
                this.registerDomListeners()

                // si hay componentes que tienen componentes incluidos, esto permite poner un nombre diferenciado a cada
                // una sus instancias, para poder referenciarla diferenciadamente. offcanvas es un ejemplo de esto.

                // TODO esto debe irse y reemplazarse por el nuevo data::instance_id
                const n1 = this.eval(this.propsData?.instanceName || this.propsData?.instance_name || this.instanceName || this.instance_name)
                const n2 = this.eval(this.name)

                // if (n1) this.$root.$refs[n1] = this;
                // if (n2) this.$root.$refs[n2] = this;
                const the_name = n1 || n2
                if (the_name) this.$root.$refs[the_name] = this
                window.api.registerVueElement(this)

            /*
            if (tiposInstanciados[cname] || !this.nodeUUID) {
                this.constructor()
                //console.log('mounted!!!', this, this.name, this.nodeUUID, this._uid, this._isBeingDestroyed, this.skippedOne)
            }
            */

            tiposInstanciados[cname] = 1
        },
        beforeDestroy() {
            window.api.unregisterVueElement(this)
        },
        /**
         * No funciona realmente con las paginas, si con algunos componentes.
         * quizas porque vuejs cachea los elementos?
         */
        /*
        beforeDestroy() {
            if (this.name) {
                delete this.$root.$refs[this.name];
                this.destructor()
            }
        },
        */
        methods: {
        }
    });

    api.components[cname] = componentDefinition
}


/**
 * Si algun elemento tiene propiedades data o methods especificas, se
 * le crea un componente para el solo. Esto permite anadir
 * listeners, etc. en una instancia sin tener que crear
 * un componente.
 * @param {*} elementDefinition
 */
api.registerElementComponent = (elementNode) => {
    // console.log('*** registerElementComponent', elementNode?.name || elementNode?.id)
    // window.console.log('registerElementComponent ', elementNode.name, api.components)
    let parentComponent = api.components[elementNode.componentType] || {}

    let componentToCreate = { ...parentComponent, ...elementNode }
    componentToCreate.id = elementNode.name // + 'Component'
    elementNode.componentType = componentToCreate.id
    // resucitar esto!!!
    // componentToCreate.methods = { ...api.parseMethodNames(parentComponent.methods), ...api.parseMethodNames(elementNode.methods) }
    componentToCreate.data = { ...parentComponent.data, ...componentToCreate.data }
    componentToCreate.expression = elementNode.expression || parentComponent.expression
    componentToCreate.props = _.uniq([...parentComponent.props || [], ..._.map(elementNode.propsData || [], (v, k) => k)])

    api.registerComponent(componentToCreate)
};

/**
 * Crea los componentes definidos en el esquema del formulario.
 * 1. toma todas las definiciones en schema.elements y crea componentes Vue para ellos.
 * 2. toma los elementos en schema.elements que tienen data o methods y crea tambien un componente
 * para ellos. Esto permite crear elementos con datos y metodos (i.e clichandler) sin tener que crear un componente.
 * 3. Finalmente, busca los elementos con componentType que sea otro elemento y lo clona. Esto permite crear
 * elementos que son clones de otros elementos, lo que puede pensarse como un mecanismo de reutilizacion/creacion de componentes en el propio formulario.
 * Estos clones pueden ser parametrizados empleando propsdata, que se ha visto que funciona.
 * @param {*} schema
 */
api.renderSchema = (schema) => {
    if (!schema) return
    console.log('Fijando node uuids ..')

    window.api.applyAll( e => {
        if (!e.nodeUUID) {
            e.nodeUUID = window.api.generateUUID()
        }
        e.children = e.children || []
        _.each(e.children, c => {
            if (!c.nodeUUID) c.nodeUUID = window.api.generateUUID()
            c.parentNodeUUID = e.nodeUUID
        })
    }, schema.elements)

    /**
     * Solamente se registran los componentes que no posean un schema element con el mismo nombre.
     * Esto permite redefinir componentes del tenant en el formulario.
     */

    let componentsNotOverriden = _.filter(schema.components, () => {
        return true // || !elementNames.includes(c.id)
    })
    _.each(componentsNotOverriden, api.registerComponent)

    const flattenedNodes = nodeUtils.flatten()

    _(flattenedNodes).each(e => {
        // evalPropsData(e)
        if (!e.name) e.name = 'anon_' + String(Math.random() * 500)
    })

    /**
     * Si un componente del tenant tiene hijos, se añaden aquí a los
     * elementos que sean de ese tipo para que se incluyan. Esto se crea
     * cuando quieres crear un componente con 3 dialogos y que estos
     * se arrastren a los formularios que usen el componente para
     * poder acceder a ellos por api.getComponent('xx') donde xx es
     * un elemento hijo del componente
     */
    _(flattenedNodes).each(e => {
        let parentComponent = api.components[e.componentType]
        if (!parentComponent) return

                let m1 = _.keyBy(parentComponent.children, 'name')
        let m2 = _.keyBy(e.children, 'name')
        let c = _.values(Object.assign(m2, m1))
        e.children = c
    })

    let dc = _.filter(flattenedNodes, n => n.data || n.methods)
    _.each(dc, api.registerElementComponent)

}

export default api
